export default __webpack_public_path__ + "static/media/cloud1.fad77335.png";